import {ResizedImageInfo} from '@/types/matrix';

export const resizeImageToFile = (
  imageFile: File,
  maxWidth: number,
  maxHeight: number,
  maxFileSize: number
): Promise<ResizedImageInfo> => {
  const imageType = imageFile.type;
  return new Promise((resolve, reject) => {
    if (imageFile.size <= maxFileSize || imageFile.type === 'image/gif') {
      const img = new Image();
      img.src = URL.createObjectURL(imageFile);
      img.onload = () => {
        resolve({
          file: imageFile,
          width: img.width,
          height: img.height
        });
      };
      img.onerror = () => reject(new Error('Image loading error'));
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(imageFile);

    img.onload = () => {
      let width = img.width;
      let height = img.height;

      if (width > maxWidth || height > maxHeight) {
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Could not get canvas context'));
        return;
      }
      ctx.drawImage(img, 0, 0, width, height);

      let quality = 0.9;
      const loopCompression = () => {
        canvas.toBlob(
          (blob) => {
            if (blob === null) {
              reject(new Error('Failed to create blob'));
              return;
            }

            if (blob.size <= maxFileSize || quality < 0.1) {
              const resizedFile = new File([blob], imageFile.name, {
                type: imageType,
                lastModified: Date.now()
              });

              resolve({
                file: resizedFile,
                width: width,
                height: height
              });
            } else {
              quality -= 0.1;
              ctx.drawImage(img, 0, 0, width, height);
              canvas.toBlob(loopCompression, imageType, quality);
            }
          },
          imageType,
          quality
        );
      };

      loopCompression();
    };
    img.onerror = () => reject(new Error('Image loading error'));
  });
};
